import React  from "react";
import { Main, Page } from './AboutStyles';
import { Typography } from "../../Components/Typography";
import { ToolBar } from "../../Components/ToolBar";

export const About = () =>{
  const text = `
    This project was made by me as a stuident from a Full Stack Developer Course,
    wich the maily purpose is to prepare people to market, and give then an oportunity
    to practice their skills. Project developed in February of 2022, by Werik Santos. DeVinHouse - Senai/Softplan
  `

  return (
    <Page>
      <ToolBar/>
      <Main>           
       <Typography str={text} fontSize="1.2rem" />
      </Main> 
    </Page>     
  );
}
